import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { CallRetentionPolicyOption } from '../models/call-retention-policy-option';

export const callRetentionPolicyOptionActions = createEagerSelectActions<CallRetentionPolicyOption>('[Call Retention Policy Options]');
